import { render, staticRenderFns } from "./RequisitionDetailDrawerOwnerSelector.vue?vue&type=template&id=9471b77a&"
import script from "./RequisitionDetailDrawerOwnerSelector.vue?vue&type=script&lang=ts&"
export * from "./RequisitionDetailDrawerOwnerSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports